// Client-side video poster (thumbnail) generation.
// Captures an early frame of a local video blob/file as a small JPEG data URL,
// so chat bubbles show a real preview instead of a black rectangle.
export function makeVideoPoster(fileOrBlob) {
  return new Promise((resolve) => {
    try {
      const url = fileOrBlob?.native ? fileOrBlob.url : URL.createObjectURL(fileOrBlob);
      const v = document.createElement("video");
      if (fileOrBlob?.native) v.crossOrigin = "anonymous";
      v.muted = true;
      v.playsInline = true;
      v.preload = "auto";
      v.src = url;
      let done = false;
      const finish = (dataUrl) => {
        if (done) return;
        done = true;
        try { if (!fileOrBlob?.native) URL.revokeObjectURL(url); } catch (e) { /* ignore */ }
        resolve(dataUrl);
      };
      const capture = () => {
        try {
          const w = v.videoWidth;
          const h = v.videoHeight;
          if (!w || !h) return finish(null);
          const scale = Math.min(1, 480 / w);
          const c = document.createElement("canvas");
          c.width = Math.round(w * scale);
          c.height = Math.round(h * scale);
          c.getContext("2d").drawImage(v, 0, 0, c.width, c.height);
          const dataUrl = c.toDataURL("image/jpeg", 0.7);
          finish(dataUrl && dataUrl.length > 100 ? dataUrl : null);
        } catch (e) {
          finish(null);
        }
      };
      v.onloadeddata = () => {
        // Seek slightly in to skip a possible black first frame
        try {
          const target = Math.min(0.5, (v.duration && isFinite(v.duration) ? v.duration : 1) * 0.1);
          if (Math.abs((v.currentTime || 0) - target) < 0.01) capture();
          else v.currentTime = target;
        } catch (e) {
          capture();
        }
      };
      v.onseeked = capture;
      v.onerror = () => finish(null);
      setTimeout(() => finish(null), 6000); // never block the send flow
    } catch (e) {
      resolve(null);
    }
  });
}
